<template>
  <!-- 数据统计 -->
  <div>
    <!-- 头部-->
    <div class="child-head">
      <!-- 标题 -->
      <div class="child-head-left flex-center">
        <img src="../../assets/area_title.png" class="head-img">
        <span>数据统计</span>
      </div>
    </div>
    <!-- 内容 -->
    <div class="count-box">
      <div class="count-item">
        <img src="../../assets/icons/52/gongyeyuanqu.png" class="count-item-img">
        <div class="count-item-text">园区</div>
        <div class="count-item-count">{{ dataList.gardenAreaCount }}</div>
        <div class="count-item-text">个</div>
      </div>
      <div class="count-item">
        <img src="../../assets/icons/52/qichexiangguan-chongdianzhan.png" class="count-item-img">
        <div class="count-item-text">充电站</div>
        <div class="count-item-count">{{ dataList.chargeStationCount }}</div>
        <div class="count-item-text">个</div>
      </div>
      <div class="count-item">
        <img src="../../assets/icons/52/kuangka.png" class="count-item-img">
        <div class="count-item-text">路线</div>
        <div class="count-item-count">{{ dataList.carCount }}</div>
        <div class="count-item-text">个</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dataList: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  watch: {
    dataList: {
      deep: true,
      immediate: true,
      handler() {
        this.v_datalist = this.dataList
      }
    }
  },
  data() {
    return {
      v_datalist: {}
    }
  },

  mounted() {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/city.scss';

.count-box {
  width: 300px;
  height: 230px;
  background: #00f0dc08;
  border: 2px solid #2496ff3b;
  margin-top: 9px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}

.count-item {
  display: flex;
  height: 50px;
  padding-left: 27px;
  align-items: center;

  &-text {
    opacity: 0.8;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #008CFF;
    letter-spacing: 0;
    line-height: 22px;
  }

  &-count {
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 26px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    line-height: 30px;
    width: 80px;
  }

  &-img {
    width: 50px;
    height: 50px;
    margin-right: 12px;
  }
}
</style>
